class DescriptionToggle extends HTMLElement {
  constructor() {
    super();
    this.description = this.querySelector('[data-description-content]');
    this.button = this.querySelector('[data-description-toggle-button]');

    if (!this.description || !this.button) return;

    this.label = this.button.querySelector('span');
    this.showMoreText = this.button.dataset.showMore;
    this.showLessText = this.button.dataset.showLess;

    this.button.addEventListener('click', this.toggle.bind(this));

    this.onResize = this.debounce(this.checkOverflow.bind(this), 200);
    window.addEventListener('resize', this.onResize);

    // Give the browser a frame to finish layout before measuring.
    requestAnimationFrame(() => this.checkOverflow());
  }

  checkOverflow() {
    const wasExpanded = this.description.classList.contains('is-expanded');
    if (wasExpanded) this.description.classList.remove('is-expanded');

    const isOverflowing = this.description.scrollHeight > this.description.clientHeight + 2;
    this.button.hidden = !isOverflowing;

    if (wasExpanded) this.description.classList.add('is-expanded');
  }

  toggle() {
    const expanded = this.description.classList.toggle('is-expanded');
    this.button.setAttribute('aria-expanded', expanded);
    if (this.label) this.label.textContent = expanded ? this.showLessText : this.showMoreText;
  }

  debounce(fn, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn(...args), wait);
    };
  }
}

customElements.define('description-toggle', DescriptionToggle);
